import React from "react";

const Card = (props: any) => {
  const { children, className } = props;

  return <div className={`card ${className}`}>{children}</div>;
};

export default Card;
